<template>
  <!-- ---------------------------------- GREEN ---------------------------------- -->
  <div class="green">
    <!-- ---------------------------------- 顶部导航栏 ---------------------------------- -->
    <Header></Header>
    <!-- ---------------------------------- RG ---------------------------------- -->
    <div class="green_button">
      <p>RG</p>
    </div>
    <!-- ---------------------------------- 海报图 ---------------------------------- -->
    <div class="banner">
      <!-- 文案 -->
      <div class="copy">
        <p>养生之道 氧在其中</p>
        <img class="green_line" src="../assets/images/icon/green-line.png" alt="">
        <img class="green_logo" src="../assets/images/icon/renoud-logo-green.png" alt="">
      </div>
    </div>
    <!-- ---------------------------------- 导航栏 ---------------------------------- -->
      <div class="green-two-mulu">
        <div class="green-two-label">
          <el-tabs v-model="activeName">
            <el-tab-pane label="全部" name="all"></el-tab-pane>
            <el-tab-pane label="有关产品" name="1"></el-tab-pane>
            <el-tab-pane label="净化功能" name="2"></el-tab-pane>
            <el-tab-pane label="产品特点" name="3"></el-tab-pane>
            <el-tab-pane label="规格" name="4"></el-tab-pane>
            <el-tab-pane label="检测" name="5"></el-tab-pane>
            <el-tab-pane label="过滤配件" name="6"></el-tab-pane>
            <el-tab-pane label="其他" name="7"></el-tab-pane>
          </el-tabs>
        </div>
        <div class="green-two-anniu">
          <div class="goumai-two-anniu-goumai">购买 ></div>
          <div class="rg-anniu-goumai">RG</div>
        </div>
      </div>
    <!-- ---------------------------------- 有关产品 ---------------------------------- -->
    <div class="green-san" v-if="activeName === 'all' || activeName === '1'">
      <div class="green-san-biaoti">有关产品</div>
      <div class="yjcp-list">
        <div class="yjcp-yycp" v-for="(item,index) in yycpProLIst" :key="index">
          <img v-lazy="item.url" alt="" />
          <span class="yjcp-yycp-title" >{{item.title}}</span >
        </div>
      </div>
    </div>
    <!-- ---------------------------------- 净化功能 ---------------------------------- -->
    <div class="green-jinghuagn" v-if="activeName === 'all' || activeName === '2'" >
      <div class="jinghua-nr">
        <div class="gr-jh-pic">
          <img src="../assets/images/green-jh.png" alt="" style="width: 100%;" />
        </div>
        <div class="gr-rig-pa">
          <div class="gr-rig-pa-tit">净化功能</div>
          <div class="gr-rig-pa-miaoshu">
            6 | 负离子发生器<br />负离子能使通常带正电荷的室内尘埃、烟雾、细菌相互聚集，使其失去在空气中自由漂浮的能力并迅速降落，从而净化空气。负离子释放对人体健康有益的小粒径负离子。负离子不仅能除尘、净化空气，还能促成人体合成和储存维生素，强化和激活人体的生理活动，因此它又被称为「空气维生素」。1000万/cm3的高浓度负离子让您的身体补充充足的「维生素」。</div>
        </div>
      </div>
    </div>
    <!-- ---------------------------------- 产品特点 ---------------------------------- -->
    <div class="green-wu" v-if="activeName === 'all' || activeName === '3'">
      <div class="gr-titbiaoti">产品特点</div>
      <AirProTDTransverse :list="greenCPTDList"></AirProTDTransverse>
    </div>
    <!-- ---------------------------------- 规格 ---------------------------------- -->
    <div class="green-liu-guige" v-if="activeName === 'all' || activeName === '4'" >
      <div class="guige-titbiaoti">规格</div>
      <div class="guige-nr">
        <div class="guige-nr-left">
          <div class="cp-mc" v-for="(item,index) in guigeLeftList" :key="index">
            <span class="cp-mc-biaoti">{{item.getit}} </span>
            <span class="cp-mc-shuoming">{{item.gename}} </span>
          </div>
        </div>
        <div class="guige-nr-rig">
          <div class="cp-mc" v-for="(item,index) in guigeRigList" :key="index">
            <span class="cp-mc-biaoti"> {{item.getit}}</span>
            <span class="cp-mc-shuoming">{{item.gename}} </span>
          </div>
        </div>
      </div>
    </div>
    <!-- ---------------------------------- 检测 ---------------------------------- -->
    <div class="green-qi-jiance" v-if="activeName === 'all' || activeName === '5'" >
      <div class="jiance-titbiaoti">检测</div>
      <div class="gr-jc-desc">根据国家标准和世卫标准</div>
      <img src="../assets/images/icon/air-jiahao.png" alt="" />
    </div>
    <!-- ---------------------------------- 过滤配件 ---------------------------------- -->
    <div class="green-jiu-guolvpj" v-if="activeName === 'all' || activeName === '6'" >
      <div class="guolvpj-titbiaoti">过滤配件</div>
      <div class="guolvpj-nr">
        <div class="peijian-left">
          <img src="../assets/images/air-glpj.png" alt="" style="width: 100%"  />
          <div class="gr-glpj-anniu">
            <div class="gr-pj-anniu-zixun">购买 ></div>
            <div class="pj-anniu-shuoming">Blueair 粒子过滤器</div>
          </div>
        </div>
        <div class="peijian-rig">
          <div class="pj-duanluo">
            <div class="pj-smaltit">微型HEPA过滤技术</div>
            <div class="pj-jianjie">
              Medic Filter Micro使用主要用于洁净室的高级过滤材料，微过滤器捕获
              99.99%的颗粒，低至0.3微米，高于目前可用的其他选项。
              活性炭捕获气体和气味活性
            </div>
          </div>
          <div class="pj-duanluo">
            <div class="pj-smaltit">微型HEPA过滤技术</div>
            <div class="pj-jianjie">
              Medic Filter Micro使用主要用于洁净室的高级过滤材料，微过滤器获
              99.99%的颗粒，低至0.3微米，高于目前可用的其他选项。
              活性炭捕获气体和气味活性
            </div>
          </div>
          <div class="pj-duanluo">
            <div class="pj-smaltit">技术规格</div>
            <div class="cp-mc">
              <span class="cp-mc-biaotigg">过滤器类型：Hepa</span>
              <span class="cp-mc-shuoming"> 分数效率：> 99.99％在0.3 pm </span>
            </div>
            <div class="cp-mc">
              <span class="cp-mc-biaotigg">过滤器数量：2 </span>
              <span class="cp-mc-shuoming">认证材料：是 </span>
            </div>
            <div class="cp-mc">
              <span class="cp-mc-biaotigg">分类：Hepa过滤器（H级）</span>
              <span class="cp-mc-shuoming">尺寸：60×30×3厘米</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- ---------------------------------- 其他 ---------------------------------- -->
    <div class="green-qitabufen-qita" v-if="activeName === 'all' || activeName === '7'" >
      <div class="qita-titbiaoti">其他</div>
      <div class="">
        <AirQiTaTransverse :list="GreenqiTaList"></AirQiTaTransverse>
      </div>
    </div>
    <!-- ---------------------------------- 顶部导航栏 ---------------------------------- -->
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer';
import AirProTDTransverse from '@/components/AirProTDTransverse';
import AirQiTaTransverse from '@/components/AirQiTaTransverse';
export default {
  components:{
    Header,
    Footer,
    AirProTDTransverse,
    AirQiTaTransverse,
  },
  data () {
    return {
      activeName: 'all',
      yycpProLIst:[
        {
          url:require('../assets/images/icon/green-pm.png'),
          title:'能探测PM2.5（颗粒物2.5微米）、CO2（二氧化碳）、NO2（二氧化氮）、HCHO（甲醛）、TVOC（挥发性有机化合物）、SO2（二氧化硫）'
        },
        {
          url:require('../assets/images/icon/green-s.png'),
          title:'智能手机APP远程管理设备，包括批量管理、定时计划、工作模式（Water Level Indicator，Smart Mode，Sleep Mode，Powerful Mode，Child Lock Feature，4G/5G connect）'
        },
        {
          url:require('../assets/images/icon/green-wj.png'),
          title:'另设投影仪专用界面，共6个指标：PM2.5、CO2、NO2、HCHO、TVOC、SO2'
        },
        {
          url:require('../assets/images/icon/green-tx.png'),
          title:'内部设后台管理系统，监管加盟商的服务和实时监察iPlant的实际情况'
        }
      ],
      greenCPTDList: [
        {
          url: require('../assets/images/air-protd1.png'),
          title: ' 童锁',
          desc: '自动禁用显示面板上的所有按钮，确保您的孩子安全'
        },
        {
          url: require('../assets/images/air-protd2.png'),
          title: 'RA488怎样连接Wi-Fi'
        },
        { url: require('../assets/images/air-protd1.png'), title: '下载说明书' },
        {
          url: require('../assets/images/air-protd2.png'),
          title: 'asdad'
        }
      ],
      guigeLeftList:[
        {
          getit:'产品名称',
          gename:'蔚诺空气488系列'
        },
        {
          getit:'适用面积',
          gename:'34 - 58 m'
        },
        {
          getit:'CADR颗粒物',
          gename:'488 m/ h'
        },
        {
          getit:'CADR甲醛',
          gename:'100 m/ h'
        },
        {
          getit:'CCM颗粒物',
          gename:'P4'
        },
        {
          getit:'甲醛',
          gename:'F4'
        },
        {
          getit:'CCM能效等级',
          gename:'高'
        },
        {
          getit:'HEPA级別',
          gename:'H13 (99.97% @ 0.3 um)'
        }
      ],
      guigeRigList:[
         {
          getit:'除菌率',
          gename:'99.98%白色葡萄球菌'
        },
        {
          getit:'高浓度负离子净化',
          gename:'1000万离子/cm3'
        },
        {
          getit:'噪音',
          gename:'38 - 68.7 dB(A) '
        },
        {
          getit:'额定电压 ',
          gename:'220 - 240 V'
        },
        {
          getit:'额定频率',
          gename:'50Hz / 60Hz'
        },
        {
          getit:' 额定功率',
          gename:' 95W '
        },
        {
          getit:'产品尺寸',
          gename:'400 x 230 x 620mm'
        },
        {
          getit:'产品净重',
          gename:'10.8公斤'
        }
      ],
      GreenqiTaList: [
        {
          url: require('../assets/images/green-ipa.png'),
          title: 'iplant怎样安装滤网'
        },
        {
          url: require('../assets/images/green-ipa2.png'),
          title: 'iplant怎样连接专用界面'
        },
        { url: require('../assets/images/green-sm.png'), title: '下载说明书' },
        {
          url: require('../assets/images/air-protd2.png'),
          title: 'asdad'
        }
      ]
    }
  },
}
</script>

<style lang="less" scoped>
// ------------- mobile端样式 -------------
@media only screen and (max-width: 960px) {     // 屏幕小于960px
}
// ------------- pc端样式 -------------
@media only screen and (min-width: 960px) {     // 屏幕大于960px
}
// ---------------------------- 顶部按钮 ---------------------------------
.green_button{
  width: 100%;
  height: 112px;
  background-color: #112653;
  display: flex;
  align-items: center;
  justify-content: center;
  P{
    width: 151px;
    border-radius: 100px;
    border: 1px solid white;
    margin: 0;
    font-size: 24px;
    color: white;
    text-align: center;
    line-height: 50px;
  }
}
// ---------------------------- 海报图 ---------------------------------
.banner{
  width: 100%;
  height: 901px;
  background: url('../assets/images/green-banner.png') no-repeat;
  background-size: 100% 100%;
  background-position: center;
  position: relative;
  // 文案
  .copy{
    position: absolute;
    top: 35%;
    left: 13%;
    p{
      font-size: 50px;
      color: #4B4B4B;
      margin: 0;
      letter-spacing: 10px;
      text-align: center;
      font-weight: lighter;
    }
    img{
      display: block;
      margin: 0 auto;
    }
    // 横线
    .green_line{
      width: 542px;
      margin: 70px 0 49px 0;
    }
    // LOGO
    .green_logo{
      width: 406px;
    }
  }
}
// ---------------------------- 导航栏 ---------------------------------
.green-two-mulu {
  display: flex;
  justify-content: space-between;
  width: 70%;
  margin: 0 auto;
  padding: 40px 0;
  .green-two-label {
    display: flex;
    align-items: center;
  }
  .green-two-label {
    display: flex;
    align-items: center;
  }
  .green-two-anniu{
    .goumai-two-anniu-goumai {
      font-size: 16px;
      font-weight: 500;
      color: #fff;
      background-color: #e60012;
      padding: 10px 20px;
      border-radius: 5px;
    }
    .rg-anniu-goumai {
      font-size: 19px;
      font-family: Noto Sans T Chinese;
      font-weight: 400;
      text-align: center;
      color: #5d5c5c;
      padding-top: 10px;
    }
  }
}
.green-two-mulu /deep/ .el-tabs__nav-wrap::after {
  background-color: #fff;
}
.green-two-mulu /deep/ .el-tabs__item.is-active {
  color: black;
  margin-bottom: 10px;
}
.green-two-mulu /deep/ .el-tabs__item:hover {
  color: black;
}
.green-two-mulu /deep/ .el-tabs__active-bar {
  background-color: #bed2c4;
}
.green-two-mulu /deep/ .el-tabs__item {
  font-size: 30px;
  font-weight: 500;
  color: #000000;
}
.green-two-mulu /deep/ .el-tabs__active-bar {
  height: 4px;
}
// ---------------------------- 有关产品 ---------------------------------
.green-san {
  background-color: #c9e5d6;
  padding: 70px 0;
  .green-san-biaoti {
    font-size: 30px;
    font-family: 微软雅黑;
    font-weight: 500;
    text-align: center;
    width: 7%;
    margin: 0 auto;
    border-bottom: 1px solid #5e5d5c;
    padding-bottom: 10px;
  }
  .yjcp-list {
    width: 80%;
    display: flex;
    flex-wrap: wrap;
    margin: 0 auto;
    .yjcp-yycp {
      width: 49%;
      display: flex;
      padding: 20px 0;
      img{
        width: 109px; 
        height: 109px; 
        margin-top: 30px
      }
      .yjcp-yycp-title {
        font-size: 30px;
        font-weight: 500;
        color: #000000;
        margin-left: 15px;
        width: 75%;
        margin-top: 40px;
      }
    }
  }
}
// ---------------------------- 净化功能 ---------------------------------
.green-jinghuagn {
  background-color: #fff;
  padding: 70px 0;
  .jinghua-nr {
    width: 80%;
    margin: 0 auto;
    display: flex;
    .gr-jh-pic {
      width: 50%;
    }
    .gr-rig-pa {
      width: 50%;
      padding-top: 120px;
      .gr-rig-pa-tit {
        text-align: center;
        font-size: 30px;
        font-family: 微软雅黑;
        font-weight: 500;
      }
      .gr-rig-pa-miaoshu {
        font-size: 25px;
        font-family: 微软雅黑;
        font-weight: normal;
        width: 80%;
        margin: 0 auto;
        border-top: 1px solid;
        border-bottom: 1px solid;
        padding: 40px 0;
        margin-top: 60px;
        line-height: 40px;
      }
    }
  }
}
// ---------------------------- 产品特点 ---------------------------------
.green-wu {
  background-color: #d6d6d7;
  padding: 70px 0 130px 0;
  .gr-titbiaoti {
    color: #0e1d41;
    font-size: 30px;
    font-weight: 500;
    text-align: center;
    width: 7%;
    margin: 0 auto;
    border-bottom: 1px solid #757474;
    padding-bottom: 10px;
  }
}
// ---------------------------- 规格 ---------------------------------
.green-liu-guige {
  background-color: #fff;
  padding: 70px 0;
  .guige-titbiaoti {
    font-size: 30px;
    font-weight: 500;
    text-align: center;
    width: 5%;
    margin: 0 auto;
    border-bottom: 1px solid #8d8c8d;
    padding-bottom: 10px;
  }
  .guige-nr {
    width: 70%;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    margin-top: 30px;
    border-left: 1px solid #999b94;
    border-right: 1px solid #999b94;
    .guige-nr-left {
      width: 40%;
      padding: 0 40px;
      .cp-mc {
        display: flex;
        .cp-mc-biaoti {
          font-size: 25px;
          font-weight: normal;
          width: 1rem;
        }
        .cp-mc-shuoming {
          font-size: 25px;
          font-weight: normal;
          align-items: flex-start;
        }
      }
    }
    .guige-nr-rig {
      width: 40%;
      padding: 0 40px;
      .cp-mc {
        display: flex;
        .cp-mc-biaoti {
          font-size: 25px;
          font-weight: normal;
          width: 1rem;
        }
        .cp-mc-shuoming {
          font-size: 25px;
          font-weight: normal;
          align-items: flex-start;
        }
      }
    }
  }
}
// ---------------------------- 检测 ---------------------------------
.green-qi-jiance {
  background-color: #fff;
  padding: 70px;
  img{
    width: 54px; 
    margin: 0 auto; 
    display: flex
  }
  .jiance-titbiaoti {
    font-size: 30px;
    font-family: 微软雅黑;
    font-weight: 500;
    text-align: center;
    color: #101f43;
    width: 5%;
    margin: 0 auto;
    border-bottom: 1px solid #868586;
    padding-bottom: 10px;
  }
  .gr-jc-desc {
    color: #101f43;
    font-size: 25px;
    font-weight: 500;
    width: 22%;
    margin: 0 auto;
    text-align: center;
    padding: 20px 0;
  }
}
// ---------------------------- 过滤配件 ---------------------------------
.green-jiu-guolvpj {
  background-color: #d4ecea;
  padding: 70px 0;
  .guolvpj-titbiaoti {
    font-size: 30px;
    font-weight: 500;
    text-align: center;
    width: 7%;
    margin: 0 auto;
    border-bottom: 1px solid #868586;
    padding-bottom: 10px;
  }
  .guolvpj-nr {
    width: 80%;
    display: flex;
    padding-top: 30px;
    margin: 0 auto;
    .peijian-left {
      width: 30%;
      margin: 0 auto;
      .gr-glpj-anniu {
        width: 52%;
        margin: 0 auto;
        padding-top: 20px;
        .gr-pj-anniu-zixun {
          font-size: 16px;
          font-weight: 500;
          color: #fff;
          background-color: #e60012;
          padding: 10px 20px;
          width: 35%;
          text-align: center;
          justify-content: center;
          margin: 0 auto;
        }
        .pj-anniu-shuoming {
          padding-top: 10px;
          color: #605f5f;
          font-size: 19px;
          font-weight: 400;
          text-align: center;
        }
      }
    }
    .peijian-rig {
      width: 55%;
      .pj-duanluo {
        padding: 20px 0;
        .pj-smaltit {
          font-size: 25px;
          line-height: 45px;
        }
        .pj-jianjie {
          font-size: 25px;
          line-height: 45px;
        }
        .cp-mc {
          display: flex;
          .cp-mc-biaotigg {
            font-size: 25px;
            font-weight: normal;
            width: 2rem;
          }
          .cp-mc-shuoming {
            font-size: 25px;
            font-weight: normal;
            align-items: flex-start;
          }
        }
      }
    }
  }
}
// ---------------------------- 其他 ---------------------------------
.green-qitabufen-qita {
  background-color: #bde1d6;
  padding: 70px 0 130px 0;
  .qita-titbiaoti {
    font-size: 30px;
    font-weight: 500;
    text-align: center;
    width: 5%;
    margin: 0 auto;
    border-bottom: 1px solid #868586;
    padding-bottom: 10px;
  }
}
 img[lazy="loading"] {
	    	width: 30%;
		    height: 30%;
        margin-left: 30%;
        margin-top: -2%;
	}
</style>


// WEBPACK FOOTER //
// src/view/green.vue